import { NzModalRef } from 'ng-zorro-antd/modal';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'app-non-modal-alert',
	templateUrl: './non-modal-alert.component.html',
	styleUrls: ['./non-modal-alert.component.scss']
})
export class NonModalAlertComponent implements OnInit {
	@Input() message;
	@Input() showButton = true;
	@Input() alertType;
	@Input() submitting;
	@Input() newCancel;
	@Output() retry = new EventEmitter();
	@Output() cancel = new EventEmitter();
	@Output() confirm = new EventEmitter();
	@Output() completeConfirmation = new EventEmitter();
	@Output() closeModal = new EventEmitter();
	checked: boolean;

	constructor() { }

	ngOnInit(): void {

	}

	confirmAlert() {
		this.setConfirm(true);
	}

	setConfirm(value: boolean) {
		this.confirm.emit(value);
	}

	confirmation() {
		this.setCompleteConfirmation(true);
	}

	setCompleteConfirmation(value: boolean) {
		this.completeConfirmation.emit(value);
	}

	cancelAlert() {
		this.setCancelAlert(true);
	}

	setCancelAlert(value: boolean) {
		this.cancel.emit(value);
	}

	cancelModalAlert() {
		this.setCancelModalAlert(true);
	}

	setCancelModalAlert(value: boolean) {
		this.closeModal.emit(value);
	}

	retryAlert() {
		this.setRetryAlert(true);
	}

	setRetryAlert(value: boolean) {
		this.retry.emit(value);
	}
}
